import { BaseModel } from '../../_base/crud';

export class ActionModel extends BaseModel {
  id: number;
  name: string;
  type: string;
  subject: string;
  body: string;
  to: any[];
  credential_id: number;
  payload: any;
  url: string;
  http_method: string;
}
